import React from 'react';
import { graphql } from "gatsby";
import PropTypes from 'prop-types';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';
import Image from '../../components/image/image';
import HubspotFormContent from '../../components/form/hubspotFormContent/hubspotFormContent';

/**
 * 
 * CMS: DatoCmsModuleForm
 * 
 */
const Form = ({data, className, ...other}) => {
  let {anchor, backgroundImage, border, form, image} = data || {};
 
  return (
    <ModuleWrapper anchor={anchor} border={border} className={`form ${backgroundImage ? '': 'form--noBackground'} ${className || ''} ${image?.url ? '' : 'form--centered'}`} {...other}>
      {
        backgroundImage && <Image data={backgroundImage} className="backgroundMedia" />
      }
      {
        image &&
        <Image data={image} className="form__img" />
      }
      {
        form &&
        <HubspotFormContent data={form} className={`form__hubspot ${backgroundImage && 'Reversed'}`} />
      }
    </ModuleWrapper>
  );
};

Form.propTypes = {
    /**
    * Data from cms
    */
    data:  PropTypes.shape({
      anchor: PropTypes.string,
      backgroundImage: PropTypes.object,
      border: PropTypes.oneOf(['', 'None', 'Gradient Border Bottom', 'Gradient Border Top', 'Lifted Top', 'Lifted Bottom', 'Lifted Fully']),
      form: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
      ]),
      image : PropTypes.object
    }),
    className: PropTypes.string,
  };

export default Form;


export const ModuleFormFragment = graphql`
  fragment ModuleFormFragment on DatoCmsModuleForm {
     
    id: originalId
    anchor
    backgroundImage{
      ...BackgroundImageFragment
    }
    border
    image{
      ...ThirdImageFragment
    }
    form{
      ...HubspotContentFragment
    }
  }`;